meedy.controller('meedy.popupCalendarTermCreateController', ['$scope', '$state', '$q', '$timeout', '$mdDialog', 'objectHelper', 'meedy.resourceModel', 'meedy.availabilityRuleModel', 'meedy.patientModel', 'meedy.termModel', 'date', 'resource', 'termWrapper', 'applicationModel', 'meedy.integrationsModel',
    function ($scope, $state, $q, $timeout, $mdDialog, objectHelper, resourceModel, availabilityRuleModel, patientModel, termModel, date, resource, termWrapper, applicationModel, integrationsModel) {

        var deferredPatientSearch = null;

        function calculatePrivateTermEndDate(date, useDefault) {
            var dateMoment = moment(date).clone();
            if (useDefault) {
                return dateMoment.add(60, 'minutes').clone().toDate();
            }
            else {
                return dateMoment.add(10, 'minutes').clone().toDate();
            }
        }

        function calculateAvailabilityRuleDates(availabilityRuleLocal, appointmentLength) {
            var availableDates = [];
            var GRANULAR = 5;
            
            if(availabilityRuleLocal.availabilityRule.endDate) {

                var currentDateMoment = moment(availabilityRuleLocal.availabilityRule.startDate);
                var endDateMoment = availabilityRuleLocal.granular ? moment(availabilityRuleLocal.availabilityRule.endDate.getTime() - (appointmentLength * 60 * 1000)) + (60 * 1000 * GRANULAR)
                    : moment(availabilityRuleLocal.availabilityRule.endDate.getTime());

                var endOfRuleReached = false;

                while (!endOfRuleReached) {
                    var newDateMoment = currentDateMoment.clone().add((availabilityRuleLocal.granular ? GRANULAR : appointmentLength), 'minutes');
                    if (newDateMoment.isSameOrBefore(endDateMoment)) {
                        availableDates.push(currentDateMoment.clone().toDate());
                        currentDateMoment = newDateMoment;
                    }
                    else {
                        endOfRuleReached = true;
                    }
                }
            }

            return availableDates;
        }

        function setData() {
            // isolated scope, needs these injected again
            $scope.Enum = Enum;
            $scope.Constant = Constant;

            $scope.resources = [];

            $scope.date = new Date(date);

            $scope.privateTerm = new TermMeedyVO();
            $scope.privateTerm.type = Enum.MEEDY.TERM_TYPE.PRIVATE_TERM;
            if(date) {
                $scope.privateTerm.begin = date;
                $scope.privateTerm.end = calculatePrivateTermEndDate($scope.privateTerm.begin, true);
            }

            $scope.cyclicTerm = new CyclicTermMeedyVO();

            $scope.appointment = new TermMeedyVO();
            $scope.appointment.type = Enum.MEEDY.TERM_TYPE.INTERNAL;
            $scope.appointment.nfz = false;

            $scope.appointmentDatesBeyondAvailability = {
                date: new Date(),
                hour: new Date()
            };

            $scope.preClickDate = true;
            $scope.isEReferralAccepted = false;

            $scope.eReferralCode = null;
            $scope.eReferralPesel = null;
            $scope.eReferralKey = null;
            $scope.useKey = false;
            $scope.eReferralType = null;

            $scope.privateTermData = {
                validPrivateTermEndDate: calculatePrivateTermEndDate($scope.privateTerm.begin, true),
                recurrenceButtons: [
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.DATA.NOT_SET', value: null }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.ENUM.RECURRENCE_PATTERN.DAY', value: Enum.MEEDY.RECURRENCE_PATTERN.DAY }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.ENUM.RECURRENCE_PATTERN.WEEK', value: Enum.MEEDY.RECURRENCE_PATTERN.WEEK })
                ]
            };

            $scope.appointmentData = {
                patientSearchText: null,
                appointmentLengths: availabilityRuleModel.generateAppointmentTimeOptions(),
                appointmentLength: undefined,
                newPatient: new PatientMeedyVO(),
                availableTerms: [],
                availabilityRuleRange: {
                    startDate: date,
                    days: 4,
                    resourceId: undefined
                },
                availableAppointmentStartDateOptions: [
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.NEAREST', value: date }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.IN_A_WEEK', value: moment(date).add(7, 'days').startOf('day').toDate() }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.IN_A_MONTH', value: moment(date).add(1, 'months').startOf('day').toDate() }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.IN_3_MONTHS', value: moment(date).add(3, 'months').startOf('day').toDate() }),
                    objectHelper.o(MeedyButtonBarButton, { label:'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.APPOINTMENT_DATE_OPTION.BEYOND_AVAILABILITY', value: "BEYOND_AVAILABILITY" })
                ],
                availableAppointmentStartDateOption: date,
                selectedAvailabilityRuleLocal: null,
                patientMode: Enum.MEEDY.CALENDAR_TERM_POPUP_PATIENT_MODE.EXISTING
            };

            //TODO
            // $scope.appointment.begin = $scope.date;

            //$scope.currentMode = resource != null ? Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT : Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM;
            $scope.currentMode = Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT;

            switch($scope.currentMode) {
                case Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT:
                    $scope.selectedIndex = 0;
                    break;
                case Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM:
                    $scope.selectedIndex = 1;
                    break;
            }

            $scope.tabsClassName = null;
            $scope.forms = {};

            if(termWrapper.appointment) {
                $scope.appointment = termWrapper.appointment;
            }

        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$watch(function () {
                return applicationModel.actionInProgress;
            }, function (newVal) {
                $scope.actionInProgress = newVal;
            });

            $scope.$watch('cyclicTerm.recurrencePattern', function (newVal) {
                if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM) {
                    if (newVal) {
                        $scope.privateTerm.cyclic = true;
                        if($scope.privateTerm.end) {
                            $scope.cyclicTerm.endDate = new Date($scope.privateTerm.end);
                        }
                    }
                    else {
                        $scope.privateTerm.cyclic = false;
                        $scope.cyclicTerm.endDate = null;
                    }
                }
            });

            $scope.$watch('privateTerm.begin', function (newVal) {
                if (newVal) {
                    $scope.privateTermData.validPrivateTermEndDate = calculatePrivateTermEndDate(newVal, false);
                }
            });

            $scope.$watch('privateTerm.end', function (newVal) {
                if (newVal) {
                    if ($scope.cyclicTerm && $scope.cyclicTerm.endDate) {
                        $scope.cyclicTerm.endDate = new Date(newVal);
                    }
                }
            });

            $scope.$watch('privateTerm.allDay', function (newVal) {
                if (newVal) {
                    $scope.privateTerm.begin = moment($scope.privateTerm.begin).clone().set({'hour': 0, 'minute': 0, 'second': 0}).toDate();
                    $scope.privateTerm.end = moment($scope.privateTerm.end).clone().set({'hour': 23, 'minute': 59, 'second': 0}).toDate();
                    $scope.privateTermData.validPrivateTermEndDate = new Date($scope.privateTerm.begin);
                }
                else if(date){
                    $scope.privateTerm.begin = date;
                    $scope.privateTerm.end = calculatePrivateTermEndDate($scope.privateTerm.begin, true);
                    $scope.privateTermData.validPrivateTermEndDate = calculatePrivateTermEndDate($scope.privateTerm.begin, true);
                }
            });

            $scope.$watch('appointment.patient', function (newVal) {
                if ($scope.forms.appointment && $scope.forms.appointment.patient) {
                    if (newVal) {
                        $scope.forms.appointment.patient.$setValidity('nopatient', true);
                    }
                    else {
                        $scope.forms.appointment.patient.$setValidity('nopatient', false);
                    }
                }
            }, true);

            $scope.$watch('appointment.resource', function (newVal) {
                if (newVal) {
                    var newResouce = newVal;

                    if(!$scope.appointmentData.appointmentLength) {
                        $scope.appointmentData.appointmentLength = _.find($scope.appointmentData.appointmentLengths, function (length) {
                            return (length == newResouce.defaultAppointmentLength);
                        });
                    }

                    $scope.appointmentData.availabilityRuleRange.resourceId = newResouce.id;
                    $scope.appointment.begin = null;
                    $scope.appointment.end = null;

                    if(!$scope.appointmentData.availabilityRuleRange.startDate) {
                        $scope.appointmentData.availabilityRuleRange.startDate = new Date();
                    }

                    $scope.resetAvailabilityRuleState();

                    availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
                        startDate: new Date($scope.appointmentData.availabilityRuleRange.startDate).setHours(0,0,0,0),
                        days: $scope.appointmentData.availabilityRuleRange.days,
                        idResource: $scope.appointmentData.availabilityRuleRange.resourceId
                    }));
                }
            });

            $scope.$watch('appointmentData.availableAppointmentStartDateOption', function (newVal, oldVal) {
                if (newVal && (newVal != oldVal) && newVal !== "BEYOND_AVAILABILITY") {
                    $scope.appointmentData.availabilityRuleRange.startDate = newVal;

                    if ($scope.appointmentData.availabilityRuleRange.resourceId) {
                        availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
                            startDate: $scope.appointmentData.availabilityRuleRange.startDate,
                            days: $scope.appointmentData.availabilityRuleRange.days,
                            idResource: $scope.appointmentData.availabilityRuleRange.resourceId
                        }));
                    }
                }
            });

            $scope.$watch('appointment.type', function () {
                if($scope.appointment.type === Enum.MEEDY.TERM_TYPE.PRESCRIPTION) {
                    $scope.appointmentData.appointmentLength = 5;
                    $scope.appointmentData.nfz = false;
                } else {
                    $scope.appointmentData.appointmentLength = $scope.appointment.resource.defaultAppointmentLength;
                }
            });

            $scope.$on(Event.MEEDY.RESOURCE.GET_RESOURCES_AVAILABLE_FOR_LOGGED_USER.SUCCESS, function (event, resources) {
                $scope.resources = resources;

                if (resource) {
                    var foundResource = _.find($scope.resources, function (availableResource) {
                       return (availableResource.id == resource.id);
                    });

                    if (foundResource) {
                        $scope.appointment.resource = foundResource;

                        $scope.appointmentData.appointmentLength = _.find($scope.appointmentData.appointmentLengths, function (appointmentLength) {
                            return (appointmentLength == $scope.appointment.resource.defaultAppointmentLength);
                        });
                    }
                }
            });

            $scope.$on(Event.MEEDY.AVAILABILITY_RULE.GET_NEAREST_AVAILABILITY_RULE_OCCURENCE.SUCCESS, function (event, data) {
                $scope.appointmentData.selectedAvailabilityRuleLocal = null;

                var upcomingTerms = _.sortBy(data, ['startDate']);

                _.remove(upcomingTerms, function (term) {
                    return term.endDate && term.endDate.getTime() < $scope.date.getTime();
                });

                if (date && resource && $scope.appointment.resource.id === resource.id && $scope.preClickDate) {
                    var clickableDate = $scope.date;
                    $scope.preClickDate = false;
                    for(var i = 0; i < upcomingTerms.length; i++) {
                        if(upcomingTerms[i].startDate.getTime() <= clickableDate.getTime() && clickableDate.getTime() < upcomingTerms[i].endDate.getTime()) {
                            var currentDate = upcomingTerms[i].startDate;
                            while(clickableDate.getTime() > currentDate.getTime() + $scope.appointmentData.appointmentLength * 60 * 1000) {
                                currentDate = new Date(currentDate.getTime() + $scope.appointmentData.appointmentLength * 60 * 1000);
                            }
                            $scope.appointment.begin = currentDate;
                            $scope.appointment.end = new Date(new Date($scope.appointment.begin).getTime() + $scope.appointmentData.appointmentLength * 60 * 1000);
                        }
                    }
                }

                var upcomingTermsLocal = [];
                _.each(upcomingTerms, function(upcomingTerm) {
                   var availabilityRuleOccurenceLocal = objectHelper.o(CalendarAvailabilityRuleOccurenceLocalVO, {
                       availabilityRule: upcomingTerm,
                       selected: false,
                       granular: false,
                       availableDates: []
                   });

                    upcomingTermsLocal.push(availabilityRuleOccurenceLocal);
                });

                var upcomingTermsByDay = _.groupBy(upcomingTermsLocal, function (availabilityRuleOccurrenceLocal) {
                    return moment(availabilityRuleOccurrenceLocal.availabilityRule.startDate).dayOfYear();
                });

                $scope.appointmentData.availableTerms = upcomingTermsByDay;
            });

            $scope.$on(Event.MEEDY.PATIENT.GET_LIST.SUCCESS, function (event, patients) {
                deferredPatientSearch.resolve(patients);
            });

            $scope.onPatientSearchTextChanged = function(patientSearchText) {
                if (patientSearchText && (patientSearchText.length > 0)) {
                    patientModel.getPatientList(objectHelper.o(PatientDataGridMeedyCriteria, {searchPhrase: patientSearchText}));
                    deferredPatientSearch = $q.defer();
                    return (deferredPatientSearch.promise);
                }
                else {
                    return null;
                }
            };

            $scope.onAvailabilityRuleGranularChange = function (availabilityRuleLocal) {
                $timeout(function () {
                    availabilityRuleLocal.availableDates = calculateAvailabilityRuleDates(availabilityRuleLocal, $scope.appointmentData.appointmentLength);
                });
            };

            $scope.onAppointmentLengthChanged = function () {
                $scope.appointment.begin = null;
                $scope.appointment.end = null;

                if ($scope.appointmentData.selectedAvailabilityRuleLocal) {
                    $scope.appointmentData.selectedAvailabilityRuleLocal.availableDates = calculateAvailabilityRuleDates($scope.appointmentData.selectedAvailabilityRuleLocal, $scope.appointmentData.appointmentLength);
                }
                else {
                    $scope.resetAvailabilityRuleState();
                }
            };
        }

        function setActions() {
            $scope.changeMode = function(mode) {
                $scope.currentMode = mode;

                if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT) {
                    $scope.tabsClassName = Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT.toLowerCase();
                }
                else if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM) {
                    $scope.tabsClassName = Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM.toLowerCase();
                }
            };

            $scope.changePatientMode = function(mode, searchText) {
                $scope.appointmentData.patientMode = mode;

                if(mode === Enum.MEEDY.CALENDAR_TERM_POPUP_PATIENT_MODE.NEW && searchText && searchText.length > 0) {
                    var spaceIndex = searchText.indexOf(' ');
                    var firstName = spaceIndex > 0 ? searchText.substring(0, searchText.indexOf(' ')) : searchText;
                    var lastName = spaceIndex > 0 ? searchText.substring(searchText.indexOf(' ') + 1, searchText.length) : '';

                    $scope.appointmentData.newPatient = new PatientMeedyVO();
                    $scope.appointmentData.newPatient.firstName = firstName;
                    $scope.appointmentData.newPatient.lastName = lastName;
                }
            };

            $scope.removePatient = function () {
                $scope.appointment.patient = null;
                $scope.appointmentData.patientSearchText = null;
            };

            $scope.showMoreAvailableTerms = function() {
                $scope.appointmentData.availabilityRuleRange.days = $scope.appointmentData.availabilityRuleRange.days + 4;
                availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
                    startDate: $scope.appointmentData.availabilityRuleRange.startDate,
                    days: $scope.appointmentData.availabilityRuleRange.days,
                    idResource: $scope.appointmentData.availabilityRuleRange.resourceId
                }));
            };

            $scope.toggleSelectAvailabilityRule = function(availabilityRuleLocal) {
                var isSelected = availabilityRuleLocal.selected;
                $scope.resetAvailabilityRuleState();
                availabilityRuleLocal.selected = !isSelected;

                if (availabilityRuleLocal.selected) {
                    availabilityRuleLocal.availableDates = calculateAvailabilityRuleDates(availabilityRuleLocal, $scope.appointmentData.appointmentLength);
                    $scope.appointmentData.selectedAvailabilityRuleLocal = availabilityRuleLocal;
                }
            };

            $scope.resetAvailabilityRuleState = function() {
                _.each($scope.appointmentData.availableTerms, function(availableTermDay) {
                    _.each(availableTermDay, function(existingAvailabilityRuleLocal) {
                        existingAvailabilityRuleLocal.selected = false;
                        existingAvailabilityRuleLocal.granular = false;
                        existingAvailabilityRuleLocal.availableDates = [];
                    });
                });

                $scope.appointmentData.selectedAvailabilityRuleLocal = null;
            };

            $scope.selectAvailableDate = function (date) {
                $scope.resetAvailabilityRuleState();

                $scope.appointment.begin = date;
                $scope.appointment.end = moment(date).clone().add($scope.appointmentData.appointmentLength, 'minutes').toDate();
            };

            $scope.selectBeyondAvailableDate = function () {
                var _date = new Date($scope.appointmentDatesBeyondAvailability.date);
                var _hours = new Date($scope.appointmentDatesBeyondAvailability.hour);
                var hours = _hours.getHours();
                var minutes = _hours.getMinutes();
                var modulusVal = minutes % 10;

                // minutes need to be from the beginning in 5 min interval
                if(modulusVal < 5) {
                    minutes = minutes - modulusVal;
                } else if(modulusVal > 5){
                    if(minutes < 50){
                        minutes = minutes - modulusVal + 10;
                    } else {
                        hours++;
                        minutes = 0;
                    }

                }

                $scope.appointment.begin = new Date(_date.getFullYear(), _date.getMonth(), _date.getDate(), hours, minutes, 0);
                $scope.appointment.end = new Date($scope.appointment.begin.getTime() + ($scope.appointmentData.appointmentLength*60*1000));
            };

            $scope.resetAppointmentDate = function () {
                $scope.appointment.begin = null;
                $scope.appointment.end = null;
            };

            $scope.save = function () {
                var successWatcherDisabler = null;
                var errorWatcherDisabler = null;


                if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.APPOINTMENT) {
                    saveAppointment();
                }
                else if ($scope.currentMode == Enum.MEEDY.CALENDAR_TERM_POPUP_MODE.PRIVATE_TERM) {
                    savePrivateTerm();
                }

                function saveAppointment () {
                    $scope.forms.appointment.$setSubmitted();

                    if ($scope.forms.appointment.$valid) {

                        termModel.checkConflicts($scope.appointment);

                        var noConflictOccurred = $scope.$on(Event.MEEDY.TERM.CHECK_CONFLICTS.SUCCESS, function (event) {
                            noConflictOccurred();

                            if ($scope.appointmentData.patientMode == Enum.MEEDY.CALENDAR_TERM_POPUP_PATIENT_MODE.NEW) {
                                $scope.appointment.patient = $scope.appointmentData.newPatient;
                            }

                            termModel.createTerm($scope.appointment);

                            successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CREATE_TERM.SUCCESS, function (event, result) {
                                successWatcherDisabler();
                                errorWatcherDisabler();

                                var createdTerm = result;
                                $scope.forms.appointment.$setPristine();

                                $mdDialog.hide(createdTerm);
                            });

                            errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CREATE_TERM.ERROR, function (event, error) {
                                successWatcherDisabler();
                                errorWatcherDisabler();
                            });

                        });

                        var termConflictOccurred = $scope.$on(Event.MEEDY.TERM.CHECK_CONFLICTS.ERROR, function (event, list) {
                            termConflictOccurred();

                            if ($scope.appointmentData.patientMode == Enum.MEEDY.CALENDAR_TERM_POPUP_PATIENT_MODE.NEW) {
                                $scope.appointment.patient = $scope.appointmentData.newPatient;
                            }

                            if(list.data && list.data.length > 0) {
                                $mdDialog.show({
                                    templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-conflicts-popup.html',
                                    controller: 'meedy.popupCalendarTermConflictsController',
                                    resolve: {
                                        terms: function () {
                                            return list.data;
                                        },
                                        message: function () {
                                            return 'T.MEEDY.MODULE.CALENDAR.APPOINTMENT.SAVE_TERM_CONFIRMATION_MESSAGE';
                                        },
                                        termWrapper: function () {
                                            return {
                                                appointment: $scope.appointment,
                                                resourceToUse: resource,
                                                date: date,
                                                action: Constant.MEEDY.DIALOG_EVENT.TERM.CREATE
                                            };
                                        }
                                    }
                                }).then(function (result) {
                                    var createdTerm = result;
                                    $mdDialog.hide(createdTerm);
                                    $state.go($state.current, {}, {reload: true});
                                }, function (error) {
                                    //
                                });
                            }
                        });

                    }
                }

                function savePrivateTerm () {
                    $scope.forms.privateTerm.$setSubmitted();

                    if ($scope.forms.privateTerm.$valid) {


                        if ($scope.privateTerm.cyclic) {
                            $scope.privateTerm.cyclicTerm = $scope.cyclicTerm;
                            $scope.privateTerm.cyclicTerm.startDate = $scope.privateTerm.begin;
                            $scope.privateTerm.cyclicTerm.startTime = $scope.privateTerm.begin;
                            $scope.privateTerm.cyclicTerm.endTime = $scope.privateTerm.cyclicTerm.endDate;
                        }
                        else {
                            $scope.privateTerm.cyclicTerm = null;
                        }

                        termModel.checkConflicts($scope.privateTerm);

                        var checkWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CHECK_CONFLICTS.SUCCESS, function (event, result) {
                            checkWatcherDisabler();

                            termModel.createTerm($scope.privateTerm);

                            successWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CREATE_TERM.SUCCESS, function (event, result) {
                                successWatcherDisabler();
                                errorWatcherDisabler();

                                var createdTerm = result;
                                $scope.forms.privateTerm.$setPristine();

                                $mdDialog.hide(createdTerm);
                            });

                            errorWatcherDisabler = $scope.$on(Event.MEEDY.TERM.CREATE_TERM.ERROR, function (event, error) {
                                successWatcherDisabler();
                                errorWatcherDisabler();
                            });
                        });

                    }
                }
            };

            $scope.ok = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.confirmEReferral = function() {
                $scope.forms.appointment.$setSubmitted();

                if ($scope.forms.appointment.$valid && $scope.appointment.resource.id
                    && (($scope.eReferralCode && $scope.eReferralPesel) || $scope.eReferralKey)) {

                    var body = new P1EReferralVO();

                    body.key = $scope.useKey ? $scope.eReferralKey : null;
                    body.code = $scope.useKey ? null : $scope.eReferralCode + $scope.eReferralPesel;
                    body.idResource = $scope.appointment.resource.id;
                    body.full = false;

                    integrationsModel.getP1EReferralPreview(body).then(function(responseData) {
                        $mdDialog.show({
                            templateUrl: 'meedy/application/view/app/calendar/popup/calendar-confirm-e-referral-popup.html',
                            controller: 'popupConfirmationController',
                            skipHide: true,
                            resolve: {
                                title: function() {
                                    return null;
                                },
                                message: function() {
                                    return responseData.html;
                                },
                                labels: function() {
                                    return [];
                                },
                                yesText: function() {
                                    return 'Akceptuj';
                                },
                                noText: function() {
                                    return 'Odrzuć';
                                }
                            }
                        }).then( function(response) {
                            $scope.isEReferralAccepted = true;

                            var eReferral = new P1EReferralTermVO();
                            eReferral.key = responseData.key;
                            eReferral.code = $scope.eReferralCode + $scope.eReferralPesel;
                            eReferral.title = responseData.title;
                            eReferral.oidRoot = responseData.oidRoot;
                            eReferral.oidExtension = responseData.oidExtension;
                            eReferral.cito = responseData.cito;
                            eReferral.issuerName = responseData.issuerName;
                            eReferral.issuerSurname = responseData.issuerSurname;
                            eReferral.nfzAvailable = responseData.nfz;

                            $scope.appointment.referrals = [];
                            $scope.appointment.referrals.push(eReferral);

                            $scope.eReferralType = responseData.nfz ? 'Pobrane e-skierowanie jest refundowane przez NFZ' : 'Pobrane e-skierowanie NIE jest refundowane przez NFZ';
                        });
                    });
                }

            };

            $scope.eReferralDataChanged = function() {
                if ($scope.isEReferralAccepted === true) {
                    $scope.isEReferralAccepted = false;
                    $scope.appointment.referrals = [];
                    $scope.eReferralType = null;
                }
            };

        }

        function configureInterface() {

        }

        function initialize() {
            resourceModel.getResourcesAvailableForLoggedUser();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
